import styled from 'styled-components'

export const Table = styled.table<{width?: string}>`
  width: ${({ width }) => width || '70%'};
  border: 1px;
  border-style: solid;
  margin-top: 5px;
`

export const THead = styled.thead`
  background-color: #DEDEDE;
`

export const Tr = styled.tr`
  border: 1px;
  border-style: solid;
`

export const Th = styled.th<{color: string}>`
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  padding: 4px;
  color: ${({ color }) => color};
`

export const TBody = styled.tbody`
`

export const Td = styled.td<{color: string}>`
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding: 2px;
  color: ${({ color }) => color};
`
